import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

import classes from './sectionIntro.module.scss';

import { useStorage } from '@/models/Storage';
import Image from '@/components/UI/Image/Image';
import patternSVG from '@/assets/images/pattern.png';
import patternSVGDark from '@/assets/images/pattern_dark.png';
import patternBlue from '@/assets/images/pattern_blue.png';
import image from '@/assets/images/intro.png';
import useMobile from '@/hooks/useMobile';

export const SectionIntro = observer(() => {
    const mobile = useMobile();
    const { darkMode } = useStorage();
    const scrollTarget = mobile ? 150 : 252;

    const introRef = useRef(null);

    const [animEnded, setAnimEnded] = useState(false);
    const [progress, updateProgress] = useState(0);

    const onScroll = () => {
        const element = introRef.current;
        if (element && animEnded) {
            const scrollProgress = Math.max(Math.min(window.scrollY / scrollTarget, 1), 0);
            updateProgress(scrollProgress);
        }
    };

    useEffect(() => {
        if (animEnded) {
            window.addEventListener('scroll', onScroll);
            return () => window.removeEventListener('scroll', onScroll);
        }
    }, [animEnded]);

    return (
        <section className={classes.intro}>
            <div className={clsx('container', classes.container)}>
                <h1 ref={introRef} className={clsx(animEnded && classes.animated)}>
                    <div
                        style={
                            animEnded
                                ? {
                                      transform: `translateX(${progress * 200}px)`,
                                  }
                                : {}
                        }
                    >
                        <span>В Арктику</span>
                        <div className={classes.patternWrapper}>
                            <div
                                className={classes.pattern}
                                style={{
                                    backgroundImage: `url('${
                                        darkMode ? patternSVGDark.src : patternSVG.src
                                    }')`,
                                }}
                            />
                        </div>
                    </div>
                    <div
                        onAnimationEnd={() => {
                            setAnimEnded(true);
                        }}
                        style={
                            animEnded
                                ? {
                                      transform: `translateX(-${progress * 200}px)`,
                                  }
                                : {}
                        }
                    >
                        <div className={classes.patternWrapper}>
                            <div
                                className={classes.pattern}
                                style={{
                                    backgroundImage: `url('${
                                        darkMode ? patternSVGDark.src : patternSVG.src
                                    }')`,
                                }}
                            />
                        </div>
                        <span>на практику</span>
                    </div>
                </h1>

                <div className={classes.content}>
                    <div className={classes.cover}>
                        <div className={classes.patternWrapper}>
                            <div
                                className={classes.pattern}
                                style={{
                                    backgroundImage: `url(${patternBlue.src})`,
                                }}
                            ></div>
                        </div>
                        <Image src={image} alt={''} className={classes.image} />
                    </div>
                    <div className={classes.text}>
                        <p>
                            Это Дмитрий и Павел, студенты&#8209;маркшейдеры из&nbsp;Тюмени.{' '}
                            <span className={clsx(classes.desktop, classes.tab)}>
                                Летом они провели свою первую практику — целый месяц! —
                                в&nbsp;Арктике. А теперь рассказывают на Пикабу:
                            </span>
                        </p>
                        <ul className={classes.desktop}>
                            <li>что такое современная нефтянка</li>
                            <li>
                                как студенту{' '}
                                <a
                                    href={
                                        'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxt&pr=%random%'
                                    }
                                    target={'_blank'}
                                    rel={'noopener noreferrer'}
                                >
                                    получить приглашение
                                </a>{' '}
                                «Газпром нефти» на практику мечты
                            </li>
                            <li>почему маркшейдеры — это профессия будущего</li>
                            <li>
                                как живут и работают вахтовики на краю земли — самом северном
                                материковом нефтепромысле России — Восточно-Мессояхском
                            </li>
                        </ul>
                        <p className={classes.desktop}>
                            Поехали! И не забудьте подписаться{' '}
                            <a
                                href={
                                    'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxu&pr=%random%'
                                }
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                            >
                                на&nbsp;телеграм-канал для молодых специалистов «В&nbsp;команде»
                            </a>
                            , чтобы не пропустить анонсы вакансий, конференций, стажировок и
                            практик.
                        </p>
                    </div>
                    <div className={classes.textMob}>
                        <p>
                            Летом они провели свою первую практику — целый месяц! — в&nbsp;Арктике.
                            А теперь рассказывают на Пикабу:
                        </p>
                        <ul>
                            <li>что такое современная нефтянка</li>
                            <li>
                                как студенту{' '}
                                <a
                                    href={
                                        'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxt&pr=%random%'
                                    }
                                    target={'_blank'}
                                    rel={'noopener noreferrer'}
                                >
                                    получить приглашение
                                </a>{' '}
                                «Газпром нефти» на практику мечты
                            </li>
                            <li>почему маркшейдеры — это профессия будущего</li>
                            <li>
                                как живут и работают вахтовики на краю земли — самом северном
                                материковом нефтепромысле России — Восточно-Мессояхском
                            </li>
                        </ul>
                        <p>
                            Поехали! И не забудьте подписаться{' '}
                            <a
                                href={
                                    'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxu&pr=%random%'
                                }
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                            >
                                на&nbsp;телеграм-канал для молодых специалистов «В&nbsp;команде»
                            </a>
                            , чтобы не пропустить анонсы вакансий, конференций, стажировок и
                            практик.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
});
